import type { GridFilterModel, GridSortModel } from "@mui/x-data-grid-premium";
import { ResourceEnum } from "src/constants/constants.ts";
import type { CreateVariantRequestParams } from "src/framework/types.ts";

export type ListQueryKeyParams = {
  page?: {
    number: number;
    size: number;
  };
  withAggregation?: boolean;
  isInfinite?: boolean;
  include?: string[];
  locale?: string;
  groupKeys?: string[];
  useSimplePagination?: boolean;
  option?: string;
  filter?: GridFilterModel;
  sort?: GridSortModel;
  resource: string;
};

export const createModuleQueries = () => {
  const queries = {
    all: ({ resource }: { resource: string }) => [resource] as const,
    list: ({
      option = "default",
      locale,
      resource,
      isInfinite = false,
      ...restParams
    }: ListQueryKeyParams) => {
      return [
        ...queries.lists({ resource }),
        isInfinite ? "infinite" : "finite",
        option,
        { params: restParams },
        locale,
      ] as const;
    },
    lists: ({ resource }: { resource: string }) =>
      [...queries.all({ resource }), "list"] as const,
    details: ({ resource }: { resource: string }) =>
      [...queries.all({ resource }), "detail"] as const,
    detail: (params: {
      id: string;
      locale?: string;
      resource: string;
      include?: string[];
      requestParams?: Record<string, any>;
    }) => {
      const { resource, id, locale, include } = params;

      return [
        ...queries.details({
          resource,
        }),
        id,
        ...(locale ? [locale] : []),
        ...(include ? [include] : []),
      ] as const;
    },
    allCreateForms: ({ resource }: { resource: string }) => {
      return [...queries.all({ resource }), "createForm"];
    },
    createFormData: ({
      resource,
      locale,
      requestParams,
    }: {
      resource: string;
      locale?: string;
      meta?: any;
      requestParams?: Record<string, any>;
    }) => {
      if (resource === ResourceEnum.Variant) {
        const _requestParams = requestParams as
          | CreateVariantRequestParams
          | undefined;

        const { product_id, ...restRequestParams } = _requestParams || {};
        return [
          ...queries.allCreateForms({ resource }),
          ...(product_id ? [product_id] : []),
          "data",
          ...(locale ? [locale] : []),
          ...(restRequestParams && Object.keys(restRequestParams).length
            ? [restRequestParams]
            : []),
        ];
      }

      return [
        ...queries.allCreateForms({ resource }),
        "data",
        ...(locale ? [locale] : []),
        ...(requestParams && Object.keys(requestParams).length
          ? [requestParams]
          : []),
      ];
    },
  } as const;
  return queries;
};
